<script lang="jsx">
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import TableBodyTr from './TableBodyTr.vue'
  import TableTd from './TableTd.vue'

  export default {
    components: {
      NewBsBox,
    },
    props: [
      'striped',
      'data',
      'allData', // 由于列固定的table，只渲染了一部分，获取不到全部的rowData，加一个参数个slot-scope用
      'columns',
      'rowStatus',
      'currentSelect',
      'handleRowClick',
      'handleRowMouseenter',
      'handleRowMouseleave',
      'tbodyTrHeightChange',
      'shouldClacHeight',
      'shouldFixedColumn',
      'fixed',
      'spanMethod',
      'propScopedSlots',
      'borderStyle',
      'defaultSize',
      'defaultAlign',
      'bs',
      'heights',
      'mouseenterActiveIndex',
      'syncFixedRowHover',
      'idKey',
      'syncFixedRowHover',
    ],
    render() {
      return (
        <NewBsBox
          bs={this.bs || {}}
          as="tbody"
        >
          {this.data.map((rowData = {}, rowIndex) => (
            <TableBodyTr
              striped={this.striped}
              key={rowData[this.idKey] || rowIndex}
              rowStatus={this.rowStatus}
              rowIndex={rowIndex}
              rowData={rowData}
              mouseenterActive={this.mouseenterActiveIndex === rowIndex}
              shouldClacHeight={this.shouldClacHeight}
              currentSelect={this.currentSelect}
              shouldFixedColumn={this.shouldFixedColumn}
              bs={{
                height: this.heights[rowIndex] ? `${this.heights[rowIndex]}px` : 'auto',
              }}
              {...{
                onClick: this.handleRowClick,
                onMouseenter: this.syncFixedRowHover ? this.handleRowMouseenter : undefined,
                onMouseleave: this.syncFixedRowHover ? this.handleRowMouseleave : undefined,
                onTbodyTrHeightChange: this.tbodyTrHeightChange,
              }}
              >
              {this.columns.map((column, colIndex) => (
                <TableTd
                  rowData={this.allData[rowIndex] || rowData}
                  rowIndex={rowIndex}
                  column={column}
                  colIndex={colIndex}
                  hidden={!this.fixed && Boolean(column.fixed)}
                  key={colIndex}
                  spanMethod={this.spanMethod}
                  propScopedSlots={this.propScopedSlots}
                  borderStyle={this.borderStyle}
                  size={column.size || this.defaultSize}
                  align={column.align || this.defaultAlign}
                />
              ))}
            </TableBodyTr>
          ))}
        </NewBsBox>
      )
    },
  }
</script>
